export enum InvoiceCharEnum {
    N = "NOT_APLLICABLE",
    T = "TRUE",
    F = "FALSE",
}
